import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';

@Component({
  standalone: true,
  imports: [FormsModule],
  template: `
    <main class="login-page">
      <section class="brand">
        <strong>IGC</strong>
        <h1>Sistema de Gestion Integrada</h1>
        <p>Acceso web a inspecciones, mantenimientos, activos, PQRS y reportes.</p>
      </section>

      <form class="login-card" (ngSubmit)="submit()">
        <h2>Iniciar sesion</h2>

        @if (error()) {
          <p class="error">{{ error() }}</p>
        }

        <label class="field">
          <span>Cedula</span>
          <input name="cedula" [(ngModel)]="cedula" autocomplete="username" required>
        </label>

        <label class="field">
          <span>Contrasena</span>
          <input name="contrasena" type="password" [(ngModel)]="contrasena" autocomplete="current-password" required>
        </label>

        <button class="btn" [disabled]="loading()">
          {{ loading() ? 'Ingresando...' : 'Ingresar' }}
        </button>
      </form>
    </main>
  `,
  styles: [`
    .login-page {
      min-height: 100vh;
      display: grid;
      grid-template-columns: minmax(0, 1fr) 420px;
      gap: 48px;
      align-items: center;
      padding: 48px;
      background: #eef3fb;
    }

    .brand strong {
      display: inline-flex;
      margin-bottom: 20px;
      background: #172033;
      color: white;
      padding: 10px 12px;
      border-radius: 6px;
      letter-spacing: .08em;
    }

    .brand h1 {
      max-width: 680px;
      margin: 0;
      font-size: 48px;
      line-height: 1.05;
    }

    .brand p {
      max-width: 560px;
      color: var(--muted);
      font-size: 18px;
    }

    .login-card {
      display: grid;
      gap: 18px;
      padding: 28px;
      background: white;
      border: 1px solid var(--line);
      border-radius: 8px;
      box-shadow: 0 18px 50px rgba(23, 32, 51, .12);
    }

    .login-card h2 {
      margin: 0 0 4px;
    }

    .error {
      margin: 0;
      color: var(--bad);
      font-weight: 700;
    }

    @media (max-width: 840px) {
      .login-page {
        grid-template-columns: 1fr;
        padding: 24px;
      }

      .brand h1 {
        font-size: 34px;
      }
    }
  `]
})
export class LoginComponent {
  cedula = '';
  contrasena = '';
  readonly loading = signal(false);
  readonly error = signal('');

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  submit(): void {
    this.error.set('');
    this.loading.set(true);

    this.auth.login(this.cedula, this.contrasena).subscribe({
      next: (user) => {
        const url = user.idRol === 1 || user.idRol === 2 ? '/dashboard' : '/login';
        void this.router.navigateByUrl(url);
      },
      error: (err) => {
        this.error.set(err?.error?.mensaje ?? 'No se pudo iniciar sesion.');
        this.loading.set(false);
      }
    });
  }
}
